import { CIBIL_ACTIONS } from "constants/actions";

export function fetchCibilDetails(requestType, page, page_size, filters) {
    return {
        type: CIBIL_ACTIONS.FETCH_CIBIL_DETAILS,
        payload: {
            requestType: requestType,
            page,
            page_size,
            filters
        }
    };
}

export function fetchedCibilDetails(requestType, page, page_size, data) {
    return {
        type: CIBIL_ACTIONS.FETCHED_CIBIL_DETAILS,
        payload: {
            requestType: requestType,
            page,
            page_size,
            data: data
        }
    };
}

export function failedFetchCibilDetails(requestType, page, page_size, error) {
    return {
        type: CIBIL_ACTIONS.FAILED_FETCH_CIBIL_DETAILS,
        payload: {
            requestType: requestType,
            page,
            page_size
        },
        error: error
    };
}

export function updateCibilDetails(requestType, data) {
    return {
        type: CIBIL_ACTIONS.UPDATE_CIBIL_DETAILS,
        payload: {
            requestType,
            data: data
        }
    };
}

export function updatedCibilDetails(requestType, data) {
    return {
        type: CIBIL_ACTIONS.UPDATED_CIBIL_DETAILS,
        payload: {
            requestType: requestType,
            data: data
        }
    };
}

export function failedUpdateCibilDetails(requestType, error) {
    return {
        type: CIBIL_ACTIONS.FAILED_UPDATE_CIBIL_DETAILS,
        payload: {
            requestType: requestType
        },
        error: error
    };
}

export function createCibilRequest(caseId, associateId) {
    return {
        type: CIBIL_ACTIONS.CIBIL_REQUEST,
        payload: {
            caseId,
            associateId
        }
    };
}

export function createdCibilRequest(caseId, associateId) {
    return {
        type: CIBIL_ACTIONS.CIBIL_REQUESTED,
        payload: {
            caseId,
            associateId
        }
    };
}

export function failedCreateCibilRequest(caseId, associateId, error) {
    return {
        type: CIBIL_ACTIONS.FAILED_CIBIL_REQUEST,
        payload: {
            caseId,
            associateId
        },
        error
    };
}